import { IQualityObservation } from 'model/QualityObservation';
import { AxiosResponse } from 'axios';
import { producerApi } from './config';

export type IQualityObservationResult = {
  result: IQualityObservation[];
  id: number;
  exception: string;
  status: number;
  isCanceled: boolean;
  isCompleted: boolean;
  isCompletedSuccessfully: boolean;
  creationOptions: number;
  asyncState: null;
  isFaulted: boolean;
};

export async function getQualityObservations(): Promise<
  AxiosResponse<IQualityObservationResult>
> {
  return producerApi.get('order/quality-observation');
}
